import { EMenuActionsTypes } from '@enums/common';

export const searchTooltipText = 'Search by branch';

export const exportActionsConfigurationComparison = [
	{
		text: 'Current page',
		id: EMenuActionsTypes.currentPage,
		disabled: false,
	},
	{
		text: 'All filtered',
		id: EMenuActionsTypes.allFiltered,
		disabled: false,
	},
	{
		text: 'All',
		id: EMenuActionsTypes.all,
		disabled: false,
	},
];
